import {useEffect, useState} from 'react';
import {ModelPermission as MP} from '../services/modelPermissionsService';
import {checkModelAccess} from '../services/accessDecisionService';
import {useAuth} from '../context/AuthContext';

export function useModelPermission(modelName: string, userLevelId: number): MP | null {
    const {user} = useAuth();
    const [perm, setPerm] = useState<MP | null>(null);
    useEffect(() => {
        let active = true;
        setPerm(null);
        if (!user) return;
        const denied: MP = {id: 0, user_level: userLevelId, model_name: modelName,
            can_read: false, can_create: false, can_update: false, can_delete: false};
        const request = checkModelAccess(modelName).then(([can_read, can_create, can_update, can_delete]) =>
            ({...denied, can_read, can_create, can_update, can_delete}));
        request.then(value => {if (active) setPerm(value);})
            .catch(() => {if (active) setPerm(denied);});
        return () => {active = false;};
    }, [modelName, userLevelId, user?.id, user?.role]);
    return perm;
}
